<template>
  <div>
    <template v-if="isLoading">
      <div>
        <v-progress-circular indeterminate color="secondary" size="20" width="3"></v-progress-circular>
      </div>
    </template>
    <v-tooltip top v-else>
      <template #activator="{ on, attrs }">
        <v-icon @click="onDownloadClick()" v-on="on" v-bind="attrs">mdi-download</v-icon>
      </template>
      Baixar
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: {
    id: {
      default: null,
      type: String
    }
  },

  data: () => ({
    isLoading: false
  }),

  methods: {
    ...mapActions('ShippersStore', ['downloadBackup']),

    async onDownloadClick() {
      try {
        this.isLoading = true;
        const data = await this.downloadBackup(this.id);
        this.$emit('feedbackReceive', { errorsType: 'success', message: 'Download realizado com sucesso!' });
        console.log(data);
      } catch (error) {
        this.$emit('feedbackReceive', { errorsType: 'error', message: 'Não foi possível realizar download.' });
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style></style>
